import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const flexBoxFn = /* @__PURE__ */ createRecipe('flex-recipe', {}, [])

const flexBoxVariantMap = {
  "direction": [
    "row",
    "column",
    "rowReverse",
    "columnReverse"
  ],
  "align": [
    "start",
    "center",
    "end",
    "stretch",
    "baseline"
  ],
  "justify": [
    "start",
    "center",
    "end",
    "between"
  ],
  "wrap": [
    "noWrap",
    "wrap",
    "wrapReverse"
  ],
  "gap": [
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9"
  ]
}

const flexBoxVariantKeys = Object.keys(flexBoxVariantMap)

export const flexBox = /* @__PURE__ */ Object.assign(memo(flexBoxFn.recipeFn), {
  __recipe__: true,
  __name__: 'flexBox',
  __getCompoundVariantCss__: flexBoxFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: flexBoxVariantKeys,
  variantMap: flexBoxVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, flexBoxVariantKeys)
  },
  getVariantProps: flexBoxFn.getVariantProps,
})